import { VideoConferenceAdapter } from '~/services/adapters/video-conference.adapter';

export class VideoConferenceService extends VideoConferenceAdapter {}
